import { MTableEditField } from '@material-table/core';
import React from 'react';
import { DISTRIBUIDOR, FABRICANTE, IMPORTADOR, UJ } from 'utils/constants/reach_role';

export default user => {
  const columns = [
    {
      title: 'Código',
      field: 'code',
      minWidth: 100,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
    },
    {
      title: 'Nome',
      field: 'name',
      minWidth: 300,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Papel Reach',
      field: 'reach_role',
      sorting: false,
      minWidth: 50,
      headerStyle: {
        textAlign: 'center',
      },
      cellStyle: {
        textAlign: 'center',
      },
      initialEditValue: UJ,
      lookup: {
        //'-': '-',
        [UJ]: 'UJ',
        [FABRICANTE]: 'Fabricante',
        [IMPORTADOR]: 'Importador',
        [DISTRIBUIDOR]: 'Distribuidor'
      },
    },
    {
      title: 'Perigoso',
      field: 'hazardous',
      type: 'boolean',
      minWidth: 50,
      initialEditValue: 'true',
      headerStyle: {
        textAlign: 'center'
      },
      cellStyle: {
        textAlign: 'center'
      },
      lookup: {
        true: 'Sim',
        false: 'Não'
      },
      render: rowData =>
        <span style={{ fontWeight: rowData.hazardous ? 'bold' : null }}>
        {rowData.hazardous ? 'Sim' : 'Não' }
      </span>
    },
    {
      title: 'Utilização',
      field: 'usage',
      sorting: false,
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
      minWidth: 300
    },
    {
      title: 'Emprego',
      field: 'usage_instructions',
      sorting: false,
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
      minWidth: 300
    },
    {
      title: 'Notas',
      field: 'notes',
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
      minWidth: 300
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
